<div class="settings-container">
  <mwo-smart-grid
    [mode]="'vertical'"
    [fullPage]="true"
    [hasSearch]="false"
  >
    <h3 previousPage>{{ "library.title" | translate }}</h3>
    <h1 header>{{ "settings.title" | translate }}</h1>
  </mwo-smart-grid>
  <div class="container">
    <section class="information">
      <img src="/assets/restaurant.png" alt="Establishment" />
      <div class="establishment">
        <h5>
          {{ resortName$ | async }}
        </h5>
        <h5>
          {{ "settings.information.place" | translate: {
              place: place$ | async
            }
          }}
        </h5>
        <div class="track">
          <p>
            {{ "settings.information.media" | translate: {
                count: availableTracks,
                plural: trackCount$ | async
              }
            }}
          </p>
          <p>
            {{
              "settings.information.playlist" | translate: {
                countPlaylist: (playlists$ | async).length
              }
            }}
          </p>
          <p>
            {{
              "settings.information.lastUpdate" | translate: {
                date: lastUpdate
              }
            }}
          </p>
        </div>
      </div>
      <div class="sync-action">
        <mwo-action-button (click)="reload()"
          [mode]="'border'"
          [icon]="'/assets/icons/update.svg'"
          [alt]="'update'"
          [translationKey]="'settings.information.update'"
        ></mwo-action-button>
        <mwo-action-button
          [mode]="'border'"
          [icon]="'/assets/icons/download.svg'"
          [alt]="'download'"
          [translationKey]="'settings.information.download'"
        ></mwo-action-button>
      </div>
    </section>
    <hr />
    <section class="additional-feature">
      <h5>{{ "settings.feat.title" | translate }}</h5>
      <mwo-switch-button
        [translationKey]="'settings.feat.next'"
        [checked]="true"
      >
      </mwo-switch-button>
      <mwo-switch-button
        [translationKey]="'settings.feat.keep'"
        [checked]="false"
      >
      </mwo-switch-button>
      <mwo-switch-button
        [translationKey]="'settings.feat.show'"
        [checked]="false"
      >
      </mwo-switch-button>
    </section>
    <hr />
    <section class="connection-manager">
      <h5>{{ "settings.connection.title" | translate }}</h5>
      <button class="action" (click)="quit()">
        <mwo-action-button
          [icon]="'/assets/icons/quit.svg'"
          [alt]="'quit'"
          [translationKey]="'settings.connection.quit'"
        ></mwo-action-button>
      </button>
      <button class="action" (click)="logout()">
        <mwo-action-button
          [icon]="'/assets/icons/signout.svg'"
          [alt]="'sign out'"
          [translationKey]="'settings.connection.signout'"
        ></mwo-action-button>
      </button>
    </section>
  </div>
</div>
